import { Navigate } from 'react-router';

function Login() {
  return <Navigate to="/start" replace />;
}

export default Login;
